<template>
  <div class="container">
    <div v-if="id">
      <TopicPostComponent
        v-if="topicInProgress"
        :editTopic="topicInProgress"
      ></TopicPostComponent>
    </div>
    <div v-else>
      <TopicPostComponent></TopicPostComponent>
    </div>
  </div>
</template>

<script>
import TopicPostComponent from "../components/TopicPostComponent";

export default {
  name: "topicCreate",
  props: ["id"],
  data: function() {
    return {
      topicInProgress: null
    };
  },
  components: {
    TopicPostComponent
  },

  // set the layout to empty when it's mounted.
  mounted: function() {
    if (this.id) {
      this.$axios.get("/topics/" + this.id).then(response => {
        this.topicInProgress = response.data;
      });
    }
  }
};
</script>
